import { render, staticRenderFns } from "./MelonTVGuide.vue?vue&type=template&id=f9f8954c&"
import script from "./MelonTVGuide.vue?vue&type=script&lang=js&"
export * from "./MelonTVGuide.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports